const DOCUMENT = 'POSITIONS_';

const actions = {
  CLEAR_STORE: DOCUMENT + 'CLEAR_STORE',
  LOAD: DOCUMENT + 'LOAD',
  LOAD_SUCCESS: DOCUMENT + 'LOAD_SUCCESS',

  clearStore: () => ({ type: actions.CLEAR_STORE }),
  loadData: data => ({ type: actions.LOAD, payload: data }),
  loadDataSuccess: data => ({ type: actions.LOAD_SUCCESS, payload: data }),
};

export default actions;
